export const fmtDate = d => {
  if (!d) return '';
  const [y,m,di] = d.split('-');
  return `${di}/${m}/${y}`;
};
export const fmtBRL = v => Number(v||0).toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
export const fmtPhone = v => {
  const d = v.replace(/\D/g,'').slice(0,11);
  if (d.length<=2)  return `(${d}`;
  if (d.length<=7)  return `(${d.slice(0,2)}) ${d.slice(2)}`;
  return `(${d.slice(0,2)}) ${d.slice(2,7)}-${d.slice(7)}`;
};
export const fmtMoeda = raw => {
  const digits = raw.replace(/\D/g,'');
  if (!digits) return '';
  const n = parseInt(digits,10);
  const r = (n/100).toFixed(2);
  const [i,d] = r.split('.');
  return `R$ ${i.replace(/\B(?=(\d{3})+(?!\d))/g,'.')},${d}`;
};
export const moedaToNum = s => {
  if (!s) return 0;
  return parseFloat(s.replace(/[R$\s.]/g,'').replace(',','.')) || 0;
};
export const fmtDur = d => {
  const n = Number(d);
  if (n >= 60) return `${Math.floor(n/60)}h${n%60>0?` ${n%60}min`:''}`;
  return `${n}min`;
};
export const today = () => new Date().toISOString().slice(0,10);
export const slugify = s => s.toLowerCase().replace(/\s+/g,'-').replace(/[^a-z0-9-]/g,'');
export const openWA = wa => { const n = wa.replace(/\D/g,''); window.open(`https://wa.me/55${n}`,'_blank'); };
export const exportCSV = (name, headers, rows) => {
  const blob = new Blob([headers.join(',')+'\n'+rows.join('\n')],{type:'text/csv'});
  const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = name; a.click();
};
